/* global Event */
import { Controller } from '@hotwired/stimulus'

export default class FilterMenuController extends Controller {
  clearAll () {
    this.element.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
      input.checked = false
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}
